module.exports = __webpack_public_path__ + "static/media/IMG_7370.615bf4b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/square/IMG_7370.jpg
// module id = 117
// module chunks = 0